import { useTranslation } from 'react-i18next'
import { HugeiconsIcon } from '@hugeicons/react'
import { ArrowLeft02Icon, CreditCardIcon, Download02Icon } from '@hugeicons-pro/core-bulk-rounded/index'
import { Button } from '@mui/material'
import PropTypes from 'prop-types'

import { ORDER_PAYMENT_STATUS, ORDER_STATUS_ARRAY } from '@/common/utils'
import OrderPaidStatusChip from '@/features/order/components/common/OrderPaidStatusChip'

import AppToolbar from './AppToolbar'

const DocumentsToolbar = ({
    buttonLabel = 'Export PDF',
    disabled = false,
    handleBackButton,
    handleExportButton,
    handlePaymentButton,
    isExporting = false,
    isInitiatingPayment,
    orderStatus,
    paymentStatus = 'Unpaid',
    paymentsEnabled = false,
}) => {
    const { t } = useTranslation()

    const orderAndPay = [
        ORDER_STATUS_ARRAY.Draft,
        ORDER_STATUS_ARRAY.Issued,
        ORDER_STATUS_ARRAY.PendingOrderConfirmation,
        ORDER_STATUS_ARRAY.Lost,
    ].includes(orderStatus)

    const isPaid =
        paymentStatus === ORDER_PAYMENT_STATUS.ManualPaid || paymentStatus === ORDER_PAYMENT_STATUS.GatewayPaid

    return (
        <AppToolbar>
            {paymentsEnabled ? <OrderPaidStatusChip paymentStatus={paymentStatus} /> : null}

            {paymentsEnabled && !isPaid ? (
                <Button
                    color="secondary"
                    data-testid="order-pay-button"
                    disabled={disabled}
                    loading={isInitiatingPayment}
                    loadingPosition="start"
                    startIcon={<HugeiconsIcon icon={CreditCardIcon} />}
                    variant="contained"
                    onClick={handlePaymentButton}
                >
                    {isInitiatingPayment ? t('Initiating payment...') : orderAndPay ? t('Order & Pay') : t('Pay Now')}
                </Button>
            ) : null}

            <Button
                color="primary"
                data-testid="export-pdf"
                disabled={disabled}
                endIcon={<HugeiconsIcon icon={Download02Icon} />}
                loading={isExporting}
                loadingPosition="end"
                variant="contained"
                onClick={handleExportButton}
            >
                {isExporting ? t('Exporting PDF...') : t(buttonLabel)}
            </Button>
            <Button
                color="secondary"
                data-testid="save"
                disabled={disabled}
                startIcon={<HugeiconsIcon icon={ArrowLeft02Icon} />}
                variant="outlined"
                onClick={handleBackButton}
            >
                {t('Back to My Orders')}
            </Button>
        </AppToolbar>
    )
}

DocumentsToolbar.propTypes = {
    handleExportButton: PropTypes.func.isRequired,
    buttonLabel: PropTypes.string,
    disabled: PropTypes.bool,
    handleBackButton: PropTypes.func,
    handlePaymentButton: PropTypes.func,
    isExporting: PropTypes.bool,
    isInitiatingPayment: PropTypes.bool,
    orderStatus: PropTypes.string,
    paymentsEnabled: PropTypes.bool,
    paymentStatus: PropTypes.oneOf([
        ORDER_PAYMENT_STATUS.Unpaid,
        ORDER_PAYMENT_STATUS.ManualPaid,
        ORDER_PAYMENT_STATUS.GatewayPaid,
    ]),
}

export default DocumentsToolbar
